import DeleteIcon from '@mui/icons-material/Delete'
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'
import Button from '@mui/material/Button'
import IconButton from '@mui/material/IconButton'
import { FileDropZone } from '../file-drop-zone'
import * as css from '../styles'
import { t } from '@lingui/core/macro'

interface ErrorPhaseProps {
  errors: Record<string, string>[]
  expectedMimeTypes: string[]
  fileName: string
  handleDrop: (files: File[]) => void
  onDeleteSelectedFile: () => void
  onSelectFileToUpload: () => void
  renderErrors: (errors: Record<string, string>[]) => React.ReactNode
}
export const ErrorPhase = ({
  errors,
  expectedMimeTypes,
  fileName,
  handleDrop,
  onDeleteSelectedFile,
  onSelectFileToUpload,
  renderErrors,
}: ErrorPhaseProps) => {
  return (
    <css.DialogContentStyled>
      <FileDropZone expectedMimeTypes={expectedMimeTypes} handleDrop={handleDrop}>
        <ErrorOutlineIcon color="error" style={{ ...css.iconStyle }} />
        {renderErrors(errors)}
        <Button color="secondary" variant="contained" onClick={onSelectFileToUpload}>
          {t`Browse files`}
        </Button>
      </FileDropZone>
      {fileName && (
        <css.SelectedFilesContainer>
          <css.FileIcon />
          <css.FileDescription variant="body2" component="span">
            {fileName}
          </css.FileDescription>
          <IconButton size="medium" onClick={onDeleteSelectedFile}>
            <DeleteIcon />
          </IconButton>
        </css.SelectedFilesContainer>
      )}
    </css.DialogContentStyled>
  )
}
